import myConnections from "../utility/connect.js";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { actions as loadingActions } from "../store/slices/loadingSlice.js";
import { id, raiseId } from "../utility/connect.js";

const BaseImage = ({
  buildSrcFromConnection = true,
  src = null,
  style = {},
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const dispatch = useDispatch();

  let fullSrc;

  if (src && buildSrcFromConnection === true) {
    fullSrc = myConnections.getImageSourceFromDb(src);
  } else {
    fullSrc = src;
  }

  useEffect(() => {
    raiseId();
    const innerId = id;
    const loadImage = (image) => {
      return new Promise((resolve, reject) => {
        const loadImg = new Image();
        loadImg.src = image;
        loadImg.onload = () => {
          return resolve(image);
        };
        loadImg.onerror = (err) => {
          return reject(err);
        };
      });
    };

    if (fullSrc) {
      const myPromise = loadImage(fullSrc);

      dispatch(
        loadingActions.addToLoadingBucket({ id: innerId, path: fullSrc, aborted: false })
      );

      myPromise
        .then((res) => {
          dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }));
          setImageLoaded(true);
        })
        .catch((err) => {
          dispatch(loadingActions.removeFromLoadingBucket({ id: innerId }));
          setImageLoaded(true);
          setImageError(true);
        });
    }

    return () => {};
  }, [fullSrc]);

  if (imageLoaded === false) {
  }

  if (imageError === true) {
  }

  return <img style={{ ...style }} src={fullSrc} />;
};

export default BaseImage;
